
import React from 'react'
import LoginPage from './components/login/login';
import { BrowserRouter as Router,Routes, Route } from 'react-router-dom';
import Signup from './components/signup/signup';
import Time from './components/ErrorPage/errorp';
import Footer from './components/footer/footer';
import Homepage from './components/carousel/carousel';
import { AuthProvider } from './components/authContext/auth';
import Card from './components/log/log';
import AdminPage from './components/loginpage/adminlog';
import Admin from './components/admin/admin';
import Juja from './components/places/juja/juja';



export const App = () => {
 
  return (
    <AuthProvider>
    <Router>
    <Routes>
      <Route path ='/' element={ <Homepage />} / >
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/footer" element={<Footer />} />
      <Route path="/error" element={<Time />} />
      <Route path="/page" element={<Card />} />
      <Route path="/loginadmin" element={<AdminPage />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/juja" element={<Juja />} />


    </Routes>
    </Router>
    </AuthProvider>
  );
};

export default App;
